import { type ReactElement, useEffect, useState } from 'react'
import LoadingScreen from '../common/LoadingScreen'
import { EMBED_TOKEN_KEY } from '@/constant/common'

type Props = {
  children: ReactElement
}

enum AuthStatus {
  LOADING = 'loading',
  AUTHORIZED = 'authorized',
  UNAUTHORIZED = 'unauthorized',
}


const EmbedPermission = ({ children }: Props) => {
  const [status, setStatus] = useState<AuthStatus>(AuthStatus.LOADING)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')

    setTimeout(() => {
      if (token === EMBED_TOKEN_KEY) {
        setStatus(AuthStatus.AUTHORIZED)
      } else {
        setStatus(AuthStatus.UNAUTHORIZED)
      }
    }, 300)
  }, [])

  if (status === AuthStatus.LOADING) return <LoadingScreen />

  if (status === AuthStatus.UNAUTHORIZED) {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex: 10000,
      }}>
        <div style={{
          backgroundColor: '#fff',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          borderRadius: '16px',
          padding: '32px',
          border: '1px solid #ccc',
        }}>
          <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '8px' }}>
            Unauthorized Access
          </h2>
          <p style={{ color: '#333' }}>
            Invalid or missing access token.<br />Please check your URL or contact admin.
          </p>
        </div>
      </div>
    )
  }

  return children
}

export default EmbedPermission
